<template>
  <div id="search-form">
    <form @submit.prevent class="container d-flex flex-column">
      <div class="row">
        <div class="block-wrapper col-md-3 mb-3">
          <fieldset class="search">
            <legend>{{$t('form.search.legend')}}</legend>
            <ncs-select field="ncs_documents.subcorpus" :allowEmpty="false" value="Learners"/>
          </fieldset>
        </div>
        <div class="block-wrapper col-md-9 mb-3">
          <fieldset class="result">
            <legend>{{$t('form.result.legend')}}</legend>
            <div class="row">
              <div class="col-md-6">
                <ncs-result-type/>
              </div>
              <div class="col-md-6">
                <ncs-search-type v-show="showElementType"/>
              </div>
              <div class="col-md-9">
                <ncs-order-selector/>
              </div>
              <div class="col-md-3">
                <ncs-page-size-selector/>
              </div>

            </div>
          </fieldset>
        </div>
      </div>
      <div class="row mb-3">
        <div class="block-wrapper col-md-3 mb-3">
          <fieldset class="sensibility">
            <legend>{{$t('form.sensibility.legend')}}</legend>
            <div class="row">
              <div class="col-md-12">
                <ncs-global-option-checkbox name="case" :value="false"/>
              </div>
              <div class="col-md-12">
                <ncs-global-option-checkbox name="accent" :value="false"/>
              </div>
            </div>
          </fieldset>
        </div>
        <div class="block-wrapper col-md-9 mb-3">
          <fieldset class="filters">
            <legend>{{$t('form.filters.legend')}}</legend>
            <div class="row">
              <div v-show="learners" class="col-md-6">
                <ncs-multi-select :disabled="!learners" name="ncs_documents.l1-learners"
                            field="ncs_documents.native_language" :dependencies="['ncs_documents.subcorpus']"/>
              </div>
              <div v-show="!learners" class="col-md-6">
                <ncs-multi-select :disabled="learners" name="ncs_documents.l1-native"
                            field="ncs_documents.native_language" :dependencies="['ncs_documents.subcorpus']"/>
              </div>
              <div class="col-md-6">
                <ncs-multi-select field="ncs_documents.task_title" :searchable="true"/>
              </div>
              <div class="col-md-6">
                <medium-filter/>
              </div>
              <div class="col-md-6" v-show="learners">
                <ncs-multi-select :disabled="!learners" name="ncs_documents.filename-learners" field="ncs_documents.filename" :searchable="true"
                                  :dependencies="['ncs_documents.subcorpus', 'ncs_documents.l1-learners']"/>
              </div>
              <div class="col-md-6" v-show="!learners">
                <ncs-multi-select :disabled="learners" name="ncs_documents.filename-native" field="ncs_documents.filename" :searchable="true"
                                  :dependencies="['ncs_documents.subcorpus', 'ncs_documents.l1-native']"/>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <ncs-select field="ncs_documents.sex"/>
              </div>
              <div class="col-md-6">
                <slider-filter field="ncs_documents.age"/>
              </div>
              <div v-show="learners" class="col-md-6">
                <ncs-multi-select field="ncs_documents.proficiency_level" :disabled="!learners"/>
              </div>

              <div v-show="learners" class="col-md-6">
                <slider-filter field="ncs_documents.age_studying_was_started" :disabled="!learners"/>
              </div>
              <div v-show="learners" class="col-md-6">
                <slider-filter field="ncs_documents.placement_test_percentage_score_int" :disabled="!learners"/>
              </div>
              <div v-show="learners" class="col-md-6">
                <slider-filter field="ncs_documents.years_studying" :disabled="!learners"/>
              </div>

              <div v-show="learners" class="col-md-6">
                <slider-filter field="ncs_documents.proficiency_self_assessment" :disabled="!learners" :interval="0.1"/>
              </div>
              <div v-show="learners" class="col-md-6">
                <slider-filter field="ncs_documents.stay_abroad_months" :disabled="!learners"/>
              </div>

            </div>
          </fieldset>
        </div>
      </div>
      <ncs-element-section/>
      <div class="d-flex justify-content-between mt-3">
        <ncs-back-button/>
        <div class="btn-group align-self-end">
          <text-download-button/>
          <ncs-search-button/>
          <ncs-reset-button/>
        </div>
      </div>
    </form>
    <ncs-result>
      <ncs-frequency-result/>
      <ncs-full-frequency-result/>
      <ncs-kwic-result/>
      <ncs-context-result :textHeader="false"/>
      <navigation-result/>
      <task-result/>
    </ncs-result>
  </div>
</template>


<script>
  import get from 'lodash/get'
  import SliderFilter from './SliderFilter'
  import MediumFilter from './MediumFilter'
  import NavigationResult from './NavigationResult'
  import TaskResult from './TaskResult'
  import TextDownloadButton from './TextDownloadButton'


  export default {
    components: {
      NavigationResult,
      TaskResult,
      SliderFilter,
      MediumFilter,
      TextDownloadButton
    },
    computed: {
      showElementType() {
        return this.$store.state.api.resultType !== 'navigation' && this.$store.state.api.resultType !== 'text'
      },
      learners() {
        return get(this.$store.state.filters.byId, ['ncs_documents.subcorpus', 'value']) === 'Learners'
      }
    },
    watch: {
      learners(value) {
        this.$store.dispatch('api/reset')
        this.$store.dispatch('elements/reset')
        if (value) {
          // Learners corpus searches will be always accent-insensitive
          this.$store.commit('elements/setGlobalOption', {name: 'accent', value: false})
        }
      }
    }
  }
</script>
